import { DataGrid, GridColDef, GridRowModel } from "@mui/x-data-grid";
import { AdminCurrentRoundResponse } from "models/AdminModels";
import { Box, Button } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import "./AdminCurrentRound.scss";
import { NhlPlayoffsResponse } from "models/NhlModels";
import { Matchup } from "models/Models";

export const AdminCurrentRound = () => {
  const [matchups, setMatchups] = useState<Matchup[]>([]);

  useEffect(() => {
    //TODO:DF Local loading indicator
    axios.get<AdminCurrentRoundResponse>(`${process.env.REACT_APP_API_URL}/admin/matchups/current`).then((r) => {
      setMatchups(r.data.matchups);
    });
  }, []);

  const columns: GridColDef[] = [
    { field: "homeTeamName", headerName: "Home", width: 150 },
    {
      field: "homeTeamWins",
      headerName: "Home Wins",
      width: 150,
      type: "number",
      editable: true,
    },
    { field: "awayTeamName", headerName: "Away", width: 150 },
    {
      field: "awayTeamWins",
      headerName: "Away Wins",
      width: 150,
      type: "number",
      editable: true,
    },
    {
      field: "isOpen",
      headerName: "Is Open",
      type: "boolean",
      width: 100,
      editable: true,
    },
    {
      field: "startsUtc",
      headerName: "Starts",
      width: 250,
      type: "dateTime",
      editable: true,
      valueGetter: ({ value }) => value && new Date(value),
    },
  ];

  const update = async () => {
    //TODO:DF local loading indicator
    var result = await axios.put<AdminCurrentRoundResponse>(`${process.env.REACT_APP_API_URL}/admin/matchups`, {
      matchups: matchups,
    });
    setMatchups(result.data.matchups);
  };

  const updateWins = async () => {
    const response = await axios.get<NhlPlayoffsResponse>(`${process.env.REACT_APP_API_URL}/nhl/playoffs`);
    response.data.series.forEach((series) => {
        const matchHome = matchups.find(
          (c) => c.homeTeamShortName === series.topSeedTeam?.abbrev.toLowerCase() && c.round === series.playoffRound
        );
        if (matchHome) {
          matchHome.homeTeamWins = series.topSeedWins;
          matchHome.awayTeamWins = series.bottomSeedWins;
        } else {
          console.log(`No matchup found for ${series.topSeedTeam?.abbrev} vs ${series.bottomSeedTeam?.abbrev}`);
        }

    });
    setMatchups(matchups.slice());
  };
  const closeRound = () => {
    matchups.forEach((m) => {
      m.isOpen = false;
    });
    setMatchups(matchups.slice());
  };

  const processRowUpdate = useCallback(
    async (newRow: GridRowModel) => {
      // Make the HTTP request to save in the backend
      const match = matchups.find(c=> c.id === newRow.id);
      if(match) {
        columns.forEach((c) => {
          if(c.editable) {
            (match as any)[c.field] = newRow[c.field];
          }
        })
      }     
      return match;
    },
    [matchups, columns],
  );

  return (
    <div className="admin-current-round">
      <div className="command-list">
        <Button variant="outlined" size="small" onClick={closeRound}>
          Close Round
        </Button>
        <Button variant="outlined" size="small" onClick={updateWins}>
          Update Wins
        </Button>
        <Button variant="outlined" size="small" onClick={update}>
          Save
        </Button>
      </div>
      <Box>
        <DataGrid
          getRowId={(c) => c.id}
          autoHeight
          rowHeight={30}
          hideFooter={true}
          rows={matchups}
          columns={columns}
          processRowUpdate={processRowUpdate}
          disableRowSelectionOnClick
        />
      </Box>
    </div>
  );
};
